import PropTypes from 'prop-types'
import React from 'react'
import Base from '../../containers/BaseContainer'
import { I18n } from 'react-redux-i18n'
import classNames from 'classnames'

import styles from './Crouton.module.scss'

class Crouton extends Base {

  constructor () {
    super()
    this.state = {

    }
  }

  render () {
    let croutonClassList = classNames(styles.crouton,
      this.props.type ? styles[this.props.type] : null,
      this.props.isDisplayed ? styles.display : null)

    return (
      <div className={croutonClassList}>
        <div className={styles.croutonIcon}></div>
        {this.props.message ? I18n.t(this.props.message) : null}
        <div className={styles.close} onClick={this.props.onCloseClick}></div>
      </div>
    )
  }

}

Crouton.propTypes = {
  message: PropTypes.string,
  type: PropTypes.string,
  isDisplayed: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
}

export default Crouton
